/* AIJ cart drawer layer — Pashupati Jewellers
   The cart drawer is the Shiprocket Smart Cart app (checkout, B2G1 progress, add-on and
   "You may also like" all come from the app). Its markup lives in an open shadow root,
   so the theme's stylesheets can't reach it: this file adopts one extra stylesheet into
   that shadow root, swaps the app's blinking offer banner for a scrolling strip (the
   app's own banner is only hidden, never removed), shakes Buy Now, and throws a short
   gold confetti burst whenever the drawer opens with items in it. No app handlers are
   touched. Strip / shake options come from the header section (#AijCartCfg).
   Brand colours for the app's own CSS variables are set in aij-base.css. */
(function () {
  'use strict';

  var CSS = [
    '.shiprocket-mini-cart-container,.mini-cart-drawer,.mini-cart-drawer button,.mini-cart-drawer input{font-family:"Jost",system-ui,-apple-system,"Segoe UI",sans-serif!important;}',
    '.mini-cart-drawer{background:#FBF6EC!important;color:#1E1612!important;box-shadow:-30px 0 70px -34px rgba(30,22,18,.6)!important;}',
    '.shiprocket-mini-cart-overlay{background:rgba(30,22,18,.45)!important;}',

    /* header */
    '.mini-cart-header{background:#FBF6EC!important;box-shadow:none!important;border-bottom:1px solid #EADFCB!important;padding:10px 18px!important;min-height:50px;}',
    '.mini-cart-title{font-family:"Playfair Display",Georgia,serif!important;font-size:18px!important;font-weight:500!important;line-height:1.2!important;color:#1E1612!important;}',
    '.mini-cart-header .item_count{font-size:12px!important;font-weight:600!important;letter-spacing:.08em;color:#B8893A!important;}',
    '.mini-cart-header .close-button{color:#1E1612!important;}',
    '.sr-cart-banner-container,.sr-banner-fade-css{height:30px!important;}',
    '.sr-cart-banner-container{font-size:10.5px!important;font-weight:500!important;letter-spacing:.26em!important;text-transform:uppercase;}',
    /* scrolling offer strip (replaces the app's blinking banner) */
    '.sr-cart-banner-container.aij-mq-on .sr-banner-fade-css,.sr-cart-banner-container.aij-mq-on .sr-banner-carousel-css,.sr-cart-banner-container.aij-mq-on .sr-banner-slide-css,.sr-cart-banner-container.aij-mq-on .sr-banner-marquee,.sr-cart-banner-container.aij-mq-on .sr-banner-static-text{display:none!important;}',
    '.aij-mq{display:flex;align-items:center;height:30px;overflow:hidden;}',
    '.aij-mq__track{display:inline-flex;flex:0 0 auto;white-space:nowrap;will-change:transform;animation:aijMq var(--aij-mq-dur,22s) linear infinite;}',
    '.aij-mq__item{display:inline-flex;align-items:center;gap:22px;padding-right:22px;font-size:10.5px;font-weight:500;letter-spacing:.22em;text-transform:uppercase;color:#F3DCA0;}',
    '.aij-mq__item::after{content:"\\25C6";font-size:7px;color:#B8893A;}',
    '@keyframes aijMq{from{transform:translateX(0)}to{transform:translateX(-50%)}}',

    /* offer progress (B2G1) */
    '#mini-cart-progress-section{background:#fff!important;border:1px solid #EADFCB!important;border-radius:16px!important;margin:14px 16px 2px!important;padding:8px 12px 4px!important;position:relative!important;top:auto!important;}',
    '.progress-bar-heading{font-family:"Playfair Display",Georgia,serif!important;font-size:16.5px!important;font-weight:500!important;line-height:1.25!important;color:#1E1612!important;}',
    '.progress-bar-sub-heading{font-size:12.5px!important;line-height:1.55!important;color:#6B5E54!important;}',
    '.progress-bar-sub-heading a{color:#5C0A18!important;font-weight:600!important;}',
    '.progress-bar{background:#EADFCB!important;border-radius:4px;}',
    '.progress{background:linear-gradient(90deg,#B8893A,#E6BF6A)!important;}',
    '.milestone-text,.milestone-text-optional{color:#6B5E54!important;}',

    /* line items */
    '#mini-cart-items-container{background:transparent!important;}',
    '.mini-cart-items{padding:0 16px!important;}',
    '.mini-cart-item-wrapper{margin:12px 0!important;}',
    '.mini-cart-item{background:#fff!important;border:1px solid #EADFCB!important;border-radius:16px!important;box-shadow:0 14px 28px -24px rgba(30,22,18,.55)!important;padding:10px 12px!important;}',
    '.sr-cart-item-image{width:70px!important;height:70px!important;max-height:70px!important;object-fit:cover!important;border:0!important;border-radius:12px!important;}',
    '.mini-cart-item-title,.mini-cart-item-title-content{font-family:"Playfair Display",Georgia,serif!important;font-size:15px!important;line-height:1.3!important;color:#1E1612!important;}',
    '.mini-cart-item-variant{color:#6B5E54!important;font-size:12px!important;}',
    '.display-price-container{font-size:15px!important;font-weight:600!important;color:#1E1612!important;}',
    '.sr-cart-cut-out-price{color:#7A6D63!important;font-size:12.5px!important;}',
    '.mini-cart-item-actions{height:30px!important;min-width:88px!important;border:1px solid #EADFCB!important;border-radius:999px!important;background:#FBF6EC!important;}',
    '.mini-cart-item-actions button{color:#1E1612!important;font-size:16px!important;}',
    '.mini-cart-item-delete{opacity:.6;}',
    '.mini-cart-item-delete:hover{opacity:1;}',
    '.badge-container{top:-7px!important;right:-7px!important;}',
    '.badge-container .discount-badge{display:none!important;}',
    '.badge-container .badge-text{position:static!important;display:flex!important;gap:2px;align-items:center;transform:none!important;padding:3px 7px;border-radius:999px;background:#5C0A18;color:#FBF1DE!important;font-size:9.5px!important;font-weight:600;line-height:1;letter-spacing:.04em;box-shadow:0 4px 10px -5px rgba(59,6,16,.8);}',
    '.badge-container .badge-text span{color:inherit!important;font-size:inherit!important;line-height:1!important;}',
    /* offer tag on a discounted line (e.g. the free item of Buy 2 Get 1) */
    '.sr-cart-item-discount-badge{background:#F3DCA0!important;color:#3B0610!important;border-radius:999px!important;font-weight:600!important;font-size:9.5px!important;letter-spacing:.06em!important;padding:3px 10px!important;box-shadow:0 4px 10px -6px rgba(0,0,0,.35)!important;}',

    /* one-tick add-on */
    '.sr-cart-single-upsell-section{margin:0 16px!important;}',
    '.sr-cart-single-upsell-content{background:#F6EEDC!important;border:1px dashed #D4B47A!important;border-radius:14px!important;box-shadow:none!important;padding:10px 12px!important;}',
    '#sr-cart-single-upsell-tick{accent-color:#5C0A18!important;}',
    '.one-tick-upsell-item-name{color:#1E1612!important;font-size:12.5px!important;width:auto!important;max-width:210px;}',
    '.one-tick-upsell-item-image{border-radius:6px!important;border:0!important;}',
    '.one-tick-upsell-text{color:#5C0A18!important;font-size:12.5px!important;font-weight:700!important;}',

    /* "You may also like": one sideways row of small cards */
    '#similar-items-container.upsell-container-combined{background:transparent!important;margin:18px 0 0!important;padding:0 0 12px 16px!important;border-radius:0!important;}',
    '.similar-item-headings-container{border-bottom:0!important;height:auto!important;margin:0 0 12px!important;}',
    '.similar-item-heading,.similar-item-heading.active-heading{font-family:"Playfair Display",Georgia,serif!important;font-size:19px!important;font-weight:500!important;color:#1E1612!important;border-bottom:0!important;padding:0!important;}',
    '.similar-item-heading.active-heading::after{content:"";display:block;width:34px;height:1px;margin-top:8px;background:linear-gradient(90deg,#B8893A,transparent);}',
    '.similar-item-upsell-container{max-height:none!important;margin-bottom:0!important;}',
    '.similar-item-wrapper{flex-direction:row!important;align-items:stretch!important;max-height:none!important;overflow-x:auto!important;overflow-y:hidden!important;gap:10px!important;padding:2px 16px 10px 0!important;scroll-snap-type:x mandatory;scrollbar-width:none;}',
    '.similar-item-wrapper::-webkit-scrollbar{display:none;}',
    '.similar-item-wrapper>div{display:contents!important;}',
    '.sr-upsell-item{flex:0 0 148px!important;width:148px!important;height:auto!important;flex-direction:column!important;justify-content:flex-start!important;margin:0!important;padding:8px!important;border:1px solid #EADFCB!important;border-radius:16px!important;background:#fff!important;scroll-snap-align:start;}',
    '.sr-upsell-image-wrapper{display:block!important;width:100%!important;height:auto!important;aspect-ratio:1/1;}',
    '.sr-upsell-item .product-img{object-fit:cover!important;border:0!important;border-radius:12px!important;padding:0!important;}',
    '.sr-upsell-item-detail{margin:9px 0 0!important;flex:1 1 auto!important;display:flex!important;flex-direction:column!important;justify-content:flex-start!important;}',
    '.sr-upsell-item-detail>div{display:flex!important;flex-direction:column!important;align-items:stretch!important;justify-content:flex-start!important;}',
    '.sr-upsell-item-detail>div:last-child{margin-top:auto!important;}',
    '.sr-upsell-item-name{font-size:12.5px!important;line-height:1.35!important;font-weight:500!important;color:#1E1612!important;min-height:2.7em;}',
    '.sr-upsell-item-price-container{flex-wrap:wrap!important;white-space:normal!important;margin-top:5px!important;}',
    '.sr-upsell-item-current-price{font-size:14px!important;font-weight:600!important;color:#1E1612!important;}',
    '.sr-upsell-item-original-price{font-size:12px!important;color:#7A6D63!important;margin-right:6px!important;}',
    '.sr-upsell-item-save-amount{color:#3F6B21!important;font-size:11.5px!important;font-weight:600!important;margin-top:3px;}',
    '.sr-upsell-item-action{position:static!important;width:100%!important;height:32px!important;margin-top:9px!important;border:1px solid #1E1612!important;border-radius:999px!important;background:#fff!important;color:#1E1612!important;font-size:11px!important;font-weight:600!important;letter-spacing:.14em!important;text-transform:uppercase;box-shadow:none!important;transition:background .25s ease,color .25s ease;}',
    '.sr-upsell-item-action:hover{background:#1E1612!important;color:#fff!important;}',

    /* footer: savings strip, total, Buy Now */
    '.mini-cart-footer{background:#fff!important;border-radius:0!important;border-top:1px solid #EADFCB;box-shadow:0 -16px 34px -26px rgba(30,22,18,.55);}',
    '.combined-offer-badge{background:#EEF6E6!important;animation:none!important;border-radius:0!important;color:#3F6B21!important;font-size:13px!important;font-weight:500!important;letter-spacing:.02em;padding:7px 10px!important;}',
    '.sr-cart-buy-section{padding:14px 16px 16px!important;gap:16px!important;}',
    '.order-summary-total{font-size:10.5px!important;font-weight:500;letter-spacing:.16em;text-transform:uppercase;color:#6B5E54!important;}',
    '.sr-cart-total-price-amount .total-price{font-family:"Playfair Display",Georgia,serif!important;font-size:21px!important;font-weight:600!important;color:#1E1612!important;}',
    '.mini-cart-order-btn{background:#1E1612!important;color:#fff!important;border-radius:999px!important;min-height:52px;font-size:14px!important;font-weight:600!important;letter-spacing:.18em!important;text-transform:uppercase;box-shadow:0 14px 28px -16px rgba(30,22,18,.9)!important;transition:background .3s ease;}',
    '.mini-cart-order-btn:hover{background:#5C0A18!important;}',
    /* Buy Now: one short shake every 2 s (toggle in the header section) */
    ':host(.aij-cart-shake) .mini-cart-order-btn:not(:disabled){animation:aijBuyShake 2s ease-in-out 1s infinite;transform-origin:50% 50%;}',
    ':host(.aij-cart-shake) .mini-cart-order-btn:hover{animation-play-state:paused;}',
    '@keyframes aijBuyShake{0%,70%,100%{transform:none}73%{transform:translateX(-4px) rotate(-1deg)}76%{transform:translateX(4px) rotate(1deg)}79%{transform:translateX(-4px) rotate(-1deg)}82%{transform:translateX(3px) rotate(.6deg)}85%{transform:translateX(-2px)}88%{transform:none}}',
    '@media (prefers-reduced-motion:reduce){.aij-mq__track,.mini-cart-order-btn{animation:none!important;}}',
    '#checkout-sticker{background:#F3DCA0!important;color:#3B0610!important;border-radius:999px!important;font-weight:600!important;font-size:9.5px!important;letter-spacing:.06em;max-height:18px!important;padding:2px 10px!important;box-shadow:0 4px 10px -6px rgba(0,0,0,.45)!important;}',

    /* empty cart */
    '.mini-cart-empty-cart h2{font-family:"Playfair Display",Georgia,serif!important;font-weight:500!important;color:#1E1612!important;}',
    '.mini-cart-shop-now-btn{background:#1E1612!important;color:#fff!important;border-radius:999px!important;letter-spacing:.14em;text-transform:uppercase;}'
  ].join('\n');

  var sheet = null;
  function host() { return document.getElementById('shiprocket-smart-cart-root'); }

  function adopt() {
    var h = host();
    var root = h && h.shadowRoot;
    if (!root) return false;
    try {
      if ('adoptedStyleSheets' in root && window.CSSStyleSheet && CSSStyleSheet.prototype.replaceSync) {
        if (!sheet) { sheet = new CSSStyleSheet(); sheet.replaceSync(CSS); }
        if (root.adoptedStyleSheets.indexOf(sheet) < 0) root.adoptedStyleSheets = root.adoptedStyleSheets.concat(sheet);
        h.classList.toggle('aij-cart-shake', cfg().shake !== '0');
      } else if (!root.getElementById('aij-cart-style')) {
        var st = document.createElement('style'); st.id = 'aij-cart-style'; st.textContent = CSS; root.appendChild(st);
        h.classList.toggle('aij-cart-shake', cfg().shake !== '0');
      }
      return true;
    } catch (e) { return false; }
  }

  function cfg() {
    var el = document.getElementById('AijCartCfg');
    return el ? el.dataset : { app: '1', offers: '', speed: '22', shake: '1' };
  }

  /* ---- offer strip: app banner texts + extra offers from the header settings ---- */
  function strip() {
    var h = host(), root = h && h.shadowRoot;
    var box = root && root.getElementById('sr-cart-banner');
    if (!box) return;
    var c = cfg(), seen = {}, texts = [];
    var add = function (t) {
      t = (t || '').replace(/\s+/g, ' ').trim();
      if (t && !seen[t.toLowerCase()]) { seen[t.toLowerCase()] = 1; texts.push(t); }
    };
    if (c.app !== '0') {
      box.querySelectorAll('.sr-banner-fade-span,.sr-banner-carousel-span,.sr-banner-slide-span,.sr-banner-marquee-item,.sr-banner-static-text')
        .forEach(function (n) { if (!n.closest('.aij-mq')) add(n.textContent); });
    }
    (c.offers || '').split('|').forEach(add);
    var sig = texts.join('|');
    var old = box.querySelector('.aij-mq');
    if (old && old.dataset.sig === sig) return;
    if (old) old.remove();
    if (!texts.length) { box.classList.remove('aij-mq-on'); return; }

    var mq = document.createElement('div');
    mq.className = 'aij-mq';
    mq.dataset.sig = sig;
    mq.setAttribute('aria-label', texts.join(' · '));
    var track = document.createElement('div');
    track.className = 'aij-mq__track';
    track.setAttribute('aria-hidden', 'true');
    track.style.setProperty('--aij-mq-dur', (parseFloat(c.speed) || 22) + 's');
    /* the track scrolls by half its width, so it holds the set twice; short sets are
       repeated first so one half is always wider than the drawer */
    var reps = Math.max(1, Math.ceil(8 / texts.length));
    for (var half = 0; half < 2; half++) {
      for (var r = 0; r < reps; r++) {
        texts.forEach(function (t) {
          var it = document.createElement('span');
          it.className = 'aij-mq__item';
          it.textContent = t;
          track.appendChild(it);
        });
      }
    }
    mq.appendChild(track);
    box.appendChild(mq);
    box.classList.add('aij-mq-on');
  }

  /* ---- confetti: three soft gold bursts over the drawer ---- */
  var lastBurst = 0;
  function confetti() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var now = Date.now();
    if (now - lastBurst < 4000) return;
    lastBurst = now;

    var h = host(), drawer = h && h.shadowRoot && h.shadowRoot.getElementById('mini-cart-drawer');
    var box = drawer ? drawer.getBoundingClientRect() : null;
    if (!box || box.width < 50) box = { left: 0, width: window.innerWidth, top: 0 };

    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var cv = document.createElement('canvas');
    cv.className = 'aij-confetti';
    cv.setAttribute('aria-hidden', 'true');
    cv.width = window.innerWidth * dpr; cv.height = window.innerHeight * dpr;
    document.body.appendChild(cv);
    var ctx = cv.getContext('2d'); ctx.scale(dpr, dpr);

    var colours = ['#B8893A', '#E6BF6A', '#F3DCA0', '#5C0A18', '#FBF1DE', '#D9B262'];
    var bits = [];
    function burst(cx) {
      for (var i = 0; i < 46; i++) {
        var a = -Math.PI / 2 + (Math.random() - 0.5) * 1.9, v = 5 + Math.random() * 7;
        bits.push({ x: cx, y: box.top + 70, vx: Math.cos(a) * v, vy: Math.sin(a) * v,
          w: 5 + Math.random() * 5, h: 3 + Math.random() * 4, r: Math.random() * 6, vr: (Math.random() - 0.5) * 0.3,
          c: colours[(Math.random() * colours.length) | 0], round: Math.random() < 0.3 });
      }
    }
    var mid = box.left + box.width / 2;
    burst(mid);
    setTimeout(function () { burst(box.left + box.width * 0.25); }, 180);
    setTimeout(function () { burst(box.left + box.width * 0.75); }, 360);

    var start = performance.now();
    (function frame(t) {
      var age = t - start;
      ctx.clearRect(0, 0, cv.width, cv.height);
      ctx.globalAlpha = age > 1700 ? Math.max(0, 1 - (age - 1700) / 700) : 1;
      bits.forEach(function (b) {
        b.vy += 0.22; b.vx *= 0.985; b.x += b.vx; b.y += b.vy; b.r += b.vr;
        ctx.save(); ctx.translate(b.x, b.y); ctx.rotate(b.r); ctx.fillStyle = b.c;
        if (b.round) { ctx.beginPath(); ctx.arc(0, 0, b.h / 1.6, 0, 6.283); ctx.fill(); }
        else ctx.fillRect(-b.w / 2, -b.h / 2, b.w, b.h * Math.abs(Math.cos(b.r * 2)) + 1);
        ctx.restore();
      });
      if (age < 2400) requestAnimationFrame(frame); else cv.remove();
    })(start);
  }

  function hasItems() {
    var h = host();
    return !!(h && h.shadowRoot && h.shadowRoot.querySelector('.mini-cart-items .mini-cart-item'));
  }

  function init() {
    if (window.__aijCart) return;
    window.__aijCart = true;

    /* the app adds its host late; adopt as soon as it appears */
    if (!adopt()) {
      var mo = new MutationObserver(function () { if (adopt()) mo.disconnect(); });
      mo.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 30000);
    }

    /* the app marks an open drawer with body.srsc-overflow-hidden */
    var open = document.body.classList.contains('srsc-overflow-hidden');
    new MutationObserver(function () {
      var now = document.body.classList.contains('srsc-overflow-hidden');
      if (now && !open) {
        adopt();
        /* the app fills the line items in just after opening: wait for them (max ~2.4 s) */
        var tries = 0;
        (function wait() {
          strip();
          if (hasItems()) confetti();
          else if (++tries < 16 && document.body.classList.contains('srsc-overflow-hidden')) setTimeout(wait, 150);
        })();
      }
      open = now;
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

    window.AIJCart = { confetti: confetti, restyle: adopt, strip: strip };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
